// extracted by mini-css-extract-plugin
export default {"inputFile":"inputwiththumbnail_inputFile__M2Lte"};